module.exports = __webpack_public_path__ + "static/media/tawjeeh-check-icon.5489bd5b.svg";